/**
 * True when Delfino refused a call before sending it, because the host did not
 * publish the method when the bridge connected. The refusal is Delfino's own: a
 * host handler cannot ask for it by throwing this code, since Comlink carries an
 * Error across the bridge with only its message, name and stack.
 */
export function isMethodNotImplementedError(error: unknown): boolean {
    return (error as { code?: string } | null)?.code === 'METHOD_NOT_IMPLEMENTED';
}

/**
 * True when a host handler refused the record it was handed: the host builds
 * the Error from the API's 422 and names it, and the name is one of the three
 * things Comlink carries across the bridge. Its message is the API's own
 * sentence, in the reader's language.
 */
export function isHostValidationError(error: unknown): boolean {
    return (error as { name?: string } | null)?.name === 'ValidationError';
}
